import React, { useState, useEffect } from 'react';
import './FloatingTabNav.css';

const FloatingTabNav = ({ 
  panels, 
  onToggle, 
  onReset,
  className = ''
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  // 편집 모드 상태 감지
  useEffect(() => {
    const checkEditMode = () => {
      const hasEditModeClass = document.body.classList.contains('edit-mode-active');
      setIsEditMode(hasEditModeClass);
      
      // 편집 모드로 전환될 때 사이드바를 축소
      if (hasEditModeClass && isExpanded) {
        setIsExpanded(false);
      }
    };

    // 초기 상태 확인
    checkEditMode();

    // MutationObserver를 사용해 body 클래스 변경 감지
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          checkEditMode();
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    return () => observer.disconnect();
  }, [isExpanded]);

  const panelConfigs = [
    {
      name: 'dashboard',
      label: '대시보드',
      icon: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="3" width="7" height="7"/>
          <rect x="14" y="3" width="7" height="7"/>
          <rect x="14" y="14" width="7" height="7"/>
          <rect x="3" y="14" width="7" height="7"/>
        </svg>
      ),
      description: '데이터 시각화 패널'
    },
    // 폼 버튼 숨김 처리
    // {
    //   name: 'forms',
    //   label: '폼',
    //   icon: (
    //     <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    //       <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    //       <polyline points="14,2 14,8 20,8"/>
    //       <line x1="16" y1="13" x2="8" y2="13"/>
    //       <line x1="16" y1="17" x2="8" y2="17"/>
    //       <polyline points="10,9 9,9 8,9"/>
    //     </svg>
    //   ),
    //   description: '입력 폼 패널'
    // },
    {
      name: 'chat',
      label: '채팅',
      icon: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
          <line x1="8" y1="9" x2="16" y2="9"/>
          <line x1="8" y1="13" x2="14" y2="13"/>
        </svg>
      ),
      description: '채팅 패널'
    }
  ];

  // 전역 마우스 이벤트로 호버 감지 (pointer-events: none이므로 전역 리스너 필요)
  useEffect(() => {
    const handleGlobalMouseMove = (e) => {
      if (isEditMode) return;

      // 마우스가 화면 왼쪽 40px 이내에 있으면 확장
      if (e.clientX <= 40) {
        if (!isExpanded) setIsExpanded(true);
      } else if (e.clientX > 200) {
        // 마우스가 충분히 멀어지면 축소
        if (isExpanded) setIsExpanded(false);
      }
    };

    document.addEventListener('mousemove', handleGlobalMouseMove);
    return () => document.removeEventListener('mousemove', handleGlobalMouseMove);
  }, [isEditMode, isExpanded]);

  return (
    <div
      className={`floating-tab-nav ${isExpanded ? 'expanded' : ''} ${isEditMode ? 'edit-mode-disabled' : ''} ${className}`}
    >
      <div className="floating-tab-content">
        {/* 패널 토글 버튼들 */}
        <div className="floating-tab-buttons">
          {panelConfigs.map(({ name, label, icon, description }) => (
            <button
              key={name}
              className={`floating-tab-button ${panels[name]?.visible ? 'active' : ''}`}
              onClick={() => onToggle(name)}
              title={`${description} 토글`}
              aria-label={`${label} 패널 토글`}
            >
              <div className="tab-icon">{icon}</div>
              <span className="tab-label">{label}</span>
              {!panels[name]?.visible && (
                <div className="tab-indicator"></div>
              )}
            </button>
          ))}
        </div>
        
        {/* 구분선 */}
        <div className="floating-tab-divider"></div>
        
        {/* 초기화 버튼 */}
        <button
          className="floating-reset-button"
          onClick={onReset}
          title="레이아웃 초기화"
          aria-label="패널 레이아웃 초기화"
        >
          <div className="reset-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="23 4 23 10 17 10"/>
              <polyline points="1 20 1 14 7 14"/>
              <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"/>
            </svg>
          </div>
          <span className="reset-label">초기화</span>
        </button>
      </div>
    </div>
  );
};

export default FloatingTabNav; 